var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPreview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 24.5,
    fill: "#EFF3F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9577 24.8184C35.9304 24.7457 35.1576 23.0364 33.4484 21.3181C31.1663 19.0451 28.2842 17.8359 25.1112 17.8359C21.9382 17.8359 19.0561 19.0451 16.774 21.3181C15.0648 23.0364 14.292 24.7457 14.2647 24.8184C14.2241 24.9101 14.2031 25.0092 14.2031 25.1094C14.2031 25.2096 14.2241 25.3087 14.2647 25.4003C14.292 25.473 15.0648 27.1823 16.774 28.9007C19.0561 31.1736 21.9382 32.3828 25.1112 32.3828C28.2842 32.3828 31.1663 31.1736 33.4484 28.9007C35.1576 27.1823 35.9304 25.473 35.9577 25.4003C35.9983 25.3087 36.0193 25.2096 36.0193 25.1094C36.0193 25.0092 35.9983 24.9101 35.9577 24.8184ZM25.1112 21.8363C25.7585 21.8363 26.3914 22.0283 26.9296 22.3879C27.4679 22.7476 27.8874 23.2588 28.1351 23.8568C28.3828 24.4549 28.4476 25.113 28.3214 25.7479C28.1951 26.3828 27.8833 26.966 27.4256 27.4238C26.9678 27.8815 26.3846 28.1932 25.7497 28.3195C25.1148 28.4458 24.4567 28.381 23.8587 28.1333C23.2606 27.8855 22.7494 27.466 22.3898 26.9278C22.0301 26.3895 21.8382 25.7567 21.8382 25.1094C21.8382 24.2413 22.183 23.4088 22.7968 22.795C23.4106 22.1812 24.2431 21.8363 25.1112 21.8363Z",
    fill: "#B2B7C2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPreview);
export default __webpack_public_path__ + "static/media/icon-preview.97630f43.svg";
export { ForwardRef as ReactComponent };